import { WallSconceRoundIcon } from './WallSconceRoundIcon';

/**
 * author: Michael Irigoyen
 * id 05EDCFBB-803B-4DA9-BDC5-17A4E43DE584
 * name wall-sconce-round
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce-round.svg
 * tags
 * - Home Automation 
 */
export const PotLightRoundIcon = WallSconceRoundIcon;
export default PotLightRoundIcon